module.exports = __webpack_public_path__ + "img/booksmob.ed845375.png";